module.exports = __webpack_public_path__ + "img/background-remover-product-after.62a7c9fb.png";